import styled from 'styled-components';

export const DevicesContainer = styled.div`
  height: 100%;

  > .ant-tabs > .ant-tabs-nav > .ant-tabs-nav-wrap {
    margin-bottom: 24px;
  }
`;
